// Mirrors backend/core/lifecycle.py's GRAPHS — kept in sync manually since it's a small,
// stable set of edges. The backend is still the source of truth/enforcement; this only
// restricts what the admin UI offers so a misclick can't even attempt an invalid move.
// See backend/LIFECYCLE.md for the full reference.
export const GRAPHS = {
  status: {
    draft: ["pending", "submitted"], pending: ["draft", "submitted"],
    submitted: ["completed", "closed"], completed: ["closed"], closed: [],
  },
  reviewed_by: { pending: ["admin", "advocate"], admin: ["advocate", "pending"], advocate: ["admin", "pending"] },
  review_status: {
    not_started: ["in_progress"], in_progress: ["submitted"],
    submitted: ["accepted", "in_progress"], accepted: ["in_progress"],
  },
  payment_status: { unpaid: ["completed", "failed"], failed: ["completed", "failed"], completed: ["refunded"], refunded: [] },
  softcopy_status: { not_generated: ["available"], available: [] },
  delivery_status: {
    not_started: ["dispatched"], dispatched: ["delivered", "failed"],
    failed: ["dispatched"], delivered: [],
  },
};

// The current value is always included so a Select can display it even when it has no
// outgoing edges (e.g. "closed").
export const nextStates = (dim, current) => [current, ...(GRAPHS[dim]?.[current] || [])];
